import { Navigate, Outlet } from 'react-router-dom';
import Loader from 'components/loader/Loader';
import useHostfullyAssist from './useHostfullyAssist';

const HostfullyAssist = () => {
  const { isAssistEligible, isLoading, isCurrentlyOrPastEnrolled } =
    useHostfullyAssist();

  if (isLoading) {
    return <Loader />;
  }

  if (!isAssistEligible || isCurrentlyOrPastEnrolled) {
    return <Navigate to="/integrations" replace />;
  }

  return <Outlet />;
};

export default HostfullyAssist;
